import React from 'react';
import styles from './Button.module.css';

/**
 * Button Component
 * @param {Object} props
 * @param {'primary' | 'secondary' | 'tertiary'} [props.variant='primary']
 * @param {'sm' | 'md' | 'lg'} [props.size='md']
 * @param {string} [props.href] - If provided, renders an <a> tag instead of <button>
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 */
export const Button = ({
    variant = 'primary',
    size = 'md',
    href,
    children,
    className = '',
    ...props
}) => {
    const combinedClassName = `${styles.btn} ${styles[variant]} ${styles[size]} ${className}`.trim();

    if (href) {
        return (
            <a href={href} className={combinedClassName} {...props}>
                {children}
            </a>
        );
    }

    return (
        <button className={combinedClassName} {...props}>
            {children}
        </button>
    );
};
